import { i18n } from '@/i18n'
import parent from '@/store/interfaces/tableViewGeneric'

const getTranslateMasterFilters = function () {
  return {
    id: { label: i18n.t('app.id'), value: '' },
    name: { label: i18n.t('app.name'), value: '' },
    email: { label: i18n.tc('users.email', 1), value: '' },
    company: { label: i18n.tc('companies.entity_name', 1), value: '' },
    role: { label: i18n.tc('app.role', 1), value: '' },
    tipoAuth: { label: i18n.t('users.tipo_auth'), value: '' },
    verTodoCompanies: { label: i18n.t('configurations.ver_todo_companies'), value: '' },
    verTodoStatuses: { label: i18n.t('configurations.ver_todo_statuses'), value: '' },
    verTodoGroups: { label: i18n.t('configurations.ver_todo_groups'), value: '' },
    activo: { label: i18n.t('app.active'), value: '' },
    empresa: { label: i18n.t('clients.entity_name'), value: '' },
    idioma: { label: i18n.t('app.language'), value: '' },
  }
}
const getColumns = function getColumns () {
  return [
    { field: 'idUsuario', width: '100px', title: i18n.t('app.id'), hidden: true, columnMenu: 'myTemplate', locked: false },
    {
      field: 'Distribuidor',
      title: i18n.t('distributors.entity_name'),
      columnMenu: 'myTemplate',
      hidden: true,
      locked: false,
      width: '180px',
      only: {
        roles: [3],
      },
    },
    {
      field: 'Cliente',
      width: '250px',
      title: i18n.t('clients.entity_name'),
      columnMenu: 'myTemplate',
      locked: false,
      hidden: true,
      only: {
        roles: [7, 8, 3],
      }, 
    },
    { field: 'Usuario', width: '250px', title: i18n.t('users.entity_name'), columnMenu: 'myTemplate', locked: false },
    { field: 'Email', width: '250px', title: i18n.tc('users.email', 1), columnMenu: 'myTemplate', locked: false },
    { field: 'idRol', width: '200px', title: i18n.tc('app.role'), columnMenu: 'myTemplate', locked: false, cell: 'enumTemplate', format: 'ROLES' },
    {
      field: 'Activo',
      width: '110px',
      title: i18n.tc('app.active'),
      columnMenu: 'myTemplate',
      locked: false,
      cell: 'checkboxTemplate',
      extraparams: { groupHeaderTemplate: ({ value, aggregates }) => value ? i18n.t('app.active') : i18n.t('app.not_active') } 
    },
    { field: 'idTipoAutenticacion', width: '210px', title: i18n.t('users.tipo_auth'), columnMenu: 'myTemplate', locked: false, cell: 'enumTemplate', format: 'TIPOS_AUTH' },
    { field: 'LangCode', width: '170px', title: i18n.t('app.language'), columnMenu: 'myTemplate', locked: false, cell: 'enumTemplate', format: 'TIPOS_IDIOMA' },
    { field: 'Grupos', width: '440px', title: i18n.t('groups.header'), columnMenu: 'myTemplate', locked: false, cell: 'groupsTemplate', type: 'boolean', sortable: false, groupable: false },
    { field: 'idEstado', width: '440px', title: i18n.t('app.status'), columnMenu: 'myTemplate', locked: false, format: '["TIPOS_ESTADO", "TIPOS_ESTADO_RECEPCION"]', cell: 'tagsTemplate', type: 'boolean', hidden: false, sortable: false, groupable: false },
    { field: 'VerTodoEstados', width: '225px', title: i18n.t('configurations.ver_todo_statuses'), columnMenu: 'myTemplate', locked: false, cell: 'checkboxTemplate' },
    { field: 'VerTodoEmpresas', width: '225px', title: i18n.t('configurations.ver_todo_companies'), columnMenu: 'myTemplate', locked: false, cell: 'checkboxTemplate' },
    { 
      field: 'idCliente', 
      title: i18n.t('clients.id_client'), 
      hidden: true, 
      columnMenu: 'myTemplate', 
      width: '150px', 
      locked: false,
      only: {
        roles: [7, 8, 3],
      },
    },
  ] 
}
const mystore = parent({ selectable: true, navigate: true, namespaced: true, getTranslateColumns: getColumns, getTranslateMasterFilters })

export default mystore
